import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'PERSON',
    icon: 'menu-person',
    label: '人员管理',
    remark: '维护移交人、接收人等人员信息',
    children: [
      {
        code: 'PERSON_HANDOVER',
        icon: 'menu-person-handover',
        label: '移交人',
        path: '/person/handover',
      },
      {
        code: 'PERSON_RECEIVER',
        icon: 'menu-person-receiver',
        label: '接收人',
        path: '/person/receiver',
      },
    ],
  },
] satisfies Menu[];
